import SafetyWidget from './safety-widget';
import { State } from 'store/state';
import { activeSafetyCarouselIdxSelector } from 'store/state/insightsContext/selectors';
import { connect } from 'react-redux';
import {
  setActiveSafetyCarousel,
  setActiveSafetyCarouselIdx,
} from 'store/state/insightsContext/actions';
import { detailPageCategorySelector } from 'store/state/selectors/analytics';
import { makeCarouselDataSelectorByType } from 'store/state/selectors/utils';
import { InsightType } from 'utils/entities';
import {
  isCollapsedInsightsSelector,
  showInsightsCarouselSelector,
} from 'store/state/selectors/insights/insightSections';


const SafetyCarouselDataSelectorByType = makeCarouselDataSelectorByType(InsightType.Safety);

const mapStateToProps = (state: State) => ({
  eventCategory: detailPageCategorySelector(state),
  carouselData: SafetyCarouselDataSelectorByType(state),
  carouselIdx: activeSafetyCarouselIdxSelector(state),
  isCollapsed: isCollapsedInsightsSelector(state),
  showCarousel: showInsightsCarouselSelector(state),
});

const mapDispatchToProps = {
  onReadMoreCarouselClick: setActiveSafetyCarousel,
  setActiveCarouselIdx: setActiveSafetyCarouselIdx,
};


export default connect(mapStateToProps, mapDispatchToProps)(SafetyWidget);
